/**
 * Maps keywords to relevant emojis for background decoration
 */
const keywordMap = {
  love: ['❤️', '💖', '✨', '🌹', '🕊️'],
  heart: ['❤️', '💕', '💗'],
  success: ['🚀', '🏆', '⭐', '📈', '🔥'],
  power: ['⚡', '🔥', '💪', '👑'],
  tech: ['💻', '⚙️', '🌐', '🧠', '📡'],
  future: ['🔮', '🚀', '✨', '🛸'],
  wisdom: ['🧠', '📚', '🦉', '🕯️', '🌱'],
  nature: ['🍃', '🌸', '☀️', '🌊', '🌲'],
  peace: ['🕊️', '🧘', '🌊', '☁️', '🎐'],
  time: ['⌛', '⏰', '⏳', '📅'],
  money: ['💰', '💎', '💵', '💳'],
  star: ['⭐', '✨', '🌟', '💫'],
  music: ['🎵', '🎶', '🎸', '🎹', '🎧'],
  travel: ['✈️', '🌍', '🏔️', '🏖️', '🎒']
};

/**
 * Curated decoration themes for manual selection
 */
export const decorationThemes = [
  { id: 'auto', name: 'Auto', icon: 'FiZap', description: 'Smart detection' },
  { id: 'minimal', name: 'Minimal', icon: 'FiMinus', emojis: ['·', '◦', '✧', '•', '▫️', '▪️', '▫'] },
  { id: 'tech', name: 'Techie', icon: 'FiCpu', emojis: ['💻', '⚙️', '🌐', '🧠', '📡', '🚀', '🤖'] },
  { id: 'seasonal', name: 'Seasonal', icon: 'FiCloudSnow', emojis: ['❄️', '🍂', '🍀', '☀️', '⛄', '🎃', '🌈'] },
  { id: 'food', name: 'Foodie', icon: 'FiCoffee', emojis: ['🍕', '☕', '🍩', '🍔', '🍦', '🍓', '🥑'] },
  { id: 'celebration', name: 'Party', icon: 'FiGift', emojis: ['🎉', '🎊', '🎈', '🎆', '🥂', '✨', '🎂'] },
  { id: 'space', name: 'Space', icon: 'FiMoon', emojis: ['🚀', '🪐', '☄️', '🛰️', '🌌', '👽', '🛸'] },
  { id: 'nature', name: 'Nature', icon: 'FiSun', emojis: ['🍃', '🌸', '☀️', '🌊', '🌲', '🦋', '🍄', '🌻'] },
  { id: 'geometric', name: 'Shapes', icon: 'FiGrid', emojis: ['◢', '◥', '▰', '▱', '◆', '◇', '⬡'] }
];

export const getDecorationsForQuote = (text, themeId = 'auto') => {
  // If a specific theme is selected (not 'auto')
  if (themeId !== 'auto') {
    const theme = decorationThemes.find(t => t.id === themeId);
    if (theme && theme.emojis) return theme.emojis;
  }

  // Default 'auto' logic
  if (!text) return ['✨', '•', '◦', '✧', '✦'];
  const words = text.toLowerCase().split(/\s+/);
  const matchedEmojis = new Set();
  
  Object.keys(keywordMap).forEach(keyword => {
    if (words.some(word => word.includes(keyword))) {
      keywordMap[keyword].forEach(emoji => matchedEmojis.add(emoji));
    }
  });

  if (matchedEmojis.size === 0) {
    return ['✨', '•', '◦', '✧', '✦'];
  }
  return Array.from(matchedEmojis).slice(0, 8);
};

export const generatePositions = (count, seed) => {
  const positions = [];
  let s = seed || 1;
  const random = () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };

  for (let i = 0; i < count; i++) {
    positions.push({
      top: `${Math.floor(random() * 88 + 6)}%`,
      left: `${Math.floor(random() * 88 + 6)}%`,
      rotate: `${Math.floor(random() * 60 - 30)}deg`,
      scale: 0.5 + random() * 1.5,
      opacity: 0.05 + random() * 0.15
    });
  }
  return positions;
};